(function initCollectionLoadMoreModule() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const STORAGE_KEY_PREFIX = 'mm_collection_loaded_count:';
  const OPTIONS_OPEN_CLASS = 'product-grid__filters__options--open';
  const PANEL_OPEN_CLASS = 'product-grid__filters__panel-wrapper--open';
  const MOBILE_BREAKPOINT = 1220;
  const ANIMATION_MS = 600;
  const PANEL_FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function forEachNode(list, callback) {
    if (!list || !callback) return;
    Array.prototype.forEach.call(list, callback);
  }

  function getUrlObject(urlLike) {
    return new URL(urlLike || window.location.href, window.location.origin);
  }

  function toRelativeUrl(urlLike) {
    const url = getUrlObject(urlLike);
    return url.pathname + url.search + url.hash;
  }

  function getStorageKey(urlLike) {
    try {
      const url = getUrlObject(urlLike);
      return STORAGE_KEY_PREFIX + url.pathname + url.search;
    } catch (error) {
      return STORAGE_KEY_PREFIX;
    }
  }

  function getStoredCount(key) {
    try {
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      const count = parseInt(raw, 10);
      return isNaN(count) || count <= 0 ? null : count;
    } catch (error) {
      return null;
    }
  }

  function setStoredCount(key, count) {
    try {
      window.sessionStorage.setItem(key, String(count));
    } catch (error) {}
  }

  function fetchPageDoc(url, signal) {
    if (typeof window.fetch !== 'function')
      return Promise.reject(new Error('no fetch'));

    const requestOptions = {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };

    if (signal) {
      requestOptions.signal = signal;
    }

    function handleFetchResponse(response) {
      if (!response.ok) {
        const networkError = new Error('Network response was not ok');
        networkError.status = response.status;
        networkError.statusText = response.statusText;
        throw networkError;
      }

      return response.text();
    }

    function parseHtmlDocument(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    return window
      .fetch(url, requestOptions)
      .then(handleFetchResponse)
      .then(parseHtmlDocument);
  }

  function getFilterState(sectionEl) {
    if (!sectionEl) return null;

    if (!sectionEl._collectionFilterState) {
      sectionEl._collectionFilterState = {
        requestId: 0,
        abortController: null,
        loadMoreAbortController: null,
        restoreAbortController: null,
        openTimerId: null,
        isAnimating: false,
        lastFocusedElement: null,
        currentSearch: window.location.search,
      };
    }

    return sectionEl._collectionFilterState;
  }

  function getSectionId(sectionEl) {
    return sectionEl ? sectionEl.getAttribute('data-section-id') : '';
  }

  function getDynamicContent(sectionEl) {
    return sectionEl
      ? sectionEl.querySelector('[data-collection-dynamic-content]')
      : null;
  }

  function syncInStockFilterInputs(sectionEl, wrapper, urlLike) {
    if (!sectionEl || !wrapper) return;

    const paramName = sectionEl.getAttribute('data-in-stock-param-name');
    if (!paramName) return;

    const filterValue =
      sectionEl.getAttribute('data-in-stock-filter-value') || '1';
    const target = getUrlObject(urlLike);
    const isActive = target.searchParams.has(paramName);

    function syncInput(input) {
      input.name = paramName;
      input.value = filterValue;

      if (input.type === 'checkbox') {
        input.checked = isActive;
      }
    }

    function syncAppliedChip(appliedChip) {
      appliedChip.hidden = !isActive;

      if (isActive) {
        const removeUrl = getUrlObject(target.toString());
        removeUrl.searchParams.delete(paramName);
        appliedChip.href = toRelativeUrl(removeUrl.toString());
      }
    }

    forEachNode(wrapper.querySelectorAll('[data-in-stock-filter]'), syncInput);
    forEachNode(
      wrapper.querySelectorAll('[data-in-stock-applied-filter]'),
      syncAppliedChip,
    );
  }

  function getDesktopForm(sectionEl) {
    return sectionEl ? sectionEl.querySelector('[data-refine-options]') : null;
  }

  function getMobileForm(sectionEl) {
    return sectionEl
      ? sectionEl.querySelector('[data-refine-panel-form]')
      : null;
  }

  function getPanel(sectionEl) {
    return sectionEl ? sectionEl.querySelector('[data-refine-panel]') : null;
  }

  function getPanelDialog(sectionEl) {
    const $panel = getPanel(sectionEl);
    return $panel
      ? $panel.querySelector('.product-grid__filters__panel')
      : null;
  }

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function isDrawerOpen(sectionEl) {
    const $desktopForm = getDesktopForm(sectionEl);
    return Boolean(
      $desktopForm && $desktopForm.classList.contains(OPTIONS_OPEN_CLASS),
    );
  }

  function clearDrawerTimer(sectionEl) {
    const state = getFilterState(sectionEl);
    if (!state || !state.openTimerId) return;

    clearTimeout(state.openTimerId);
    state.openTimerId = null;
  }

  function openDrawer(sectionEl, immediate) {
    const $desktopForm = getDesktopForm(sectionEl);
    const state = getFilterState(sectionEl);

    if (!$desktopForm || !state) return;

    clearDrawerTimer(sectionEl);

    if (immediate) {
      $desktopForm.classList.add(OPTIONS_OPEN_CLASS);
      $desktopForm.style.maxWidth = '';
      state.isAnimating = false;
      return;
    }

    state.isAnimating = true;
    $desktopForm.style.maxWidth = 'none';

    const naturalWidth = $desktopForm.scrollWidth;

    $desktopForm.style.maxWidth = '0';
    void $desktopForm.offsetWidth;
    $desktopForm.style.maxWidth = naturalWidth + 'px';
    $desktopForm.classList.add(OPTIONS_OPEN_CLASS);

    function onDrawerOpenAnimationComplete() {
      $desktopForm.style.maxWidth = '';
      state.openTimerId = null;
      state.isAnimating = false;
    }

    state.openTimerId = window.setTimeout(
      onDrawerOpenAnimationComplete,
      ANIMATION_MS,
    );
  }

  function closeDrawer(sectionEl, immediate) {
    const $desktopForm = getDesktopForm(sectionEl);
    const state = getFilterState(sectionEl);

    if (!$desktopForm || !state) return;

    clearDrawerTimer(sectionEl);

    if (immediate) {
      $desktopForm.classList.remove(OPTIONS_OPEN_CLASS);
      $desktopForm.style.maxWidth = '';
      state.isAnimating = false;
      return;
    }

    state.isAnimating = true;
    $desktopForm.style.maxWidth = $desktopForm.offsetWidth + 'px';
    void $desktopForm.offsetWidth;
    $desktopForm.style.maxWidth = '0';
    $desktopForm.classList.remove(OPTIONS_OPEN_CLASS);

    function onDrawerCloseAnimationComplete() {
      $desktopForm.style.maxWidth = '';
      state.openTimerId = null;
      state.isAnimating = false;
    }

    state.openTimerId = window.setTimeout(
      onDrawerCloseAnimationComplete,
      ANIMATION_MS,
    );
  }

  function toggleDrawer(sectionEl) {
    const state = getFilterState(sectionEl);

    if (!state || state.isAnimating) return;

    if (isDrawerOpen(sectionEl)) {
      closeDrawer(sectionEl);
      return;
    }

    openDrawer(sectionEl);
  }

  function isPanelOpen(sectionEl) {
    const $panel = getPanel(sectionEl);
    return Boolean($panel && $panel.classList.contains(PANEL_OPEN_CLASS));
  }

  function getPanelFocusableElements(sectionEl) {
    const $panelDialog = getPanelDialog(sectionEl);
    if (!$panelDialog) return [];

    function isFocusablePanelElement($element) {
      return !$element.hasAttribute('hidden') && $element.offsetParent !== null;
    }

    return Array.prototype.filter.call(
      $panelDialog.querySelectorAll(PANEL_FOCUSABLE_SELECTOR),
      isFocusablePanelElement,
    );
  }

  function openPanel(sectionEl) {
    const $panel = getPanel(sectionEl);
    const $panelDialog = getPanelDialog(sectionEl);
    const state = getFilterState(sectionEl);

    if (!$panel || !state) return;

    state.lastFocusedElement = document.activeElement;
    $panel.classList.add(PANEL_OPEN_CLASS);
    document.body.style.overflow = 'hidden';

    const focusableElements = getPanelFocusableElements(sectionEl);
    if (focusableElements.length) {
      focusableElements[0].focus();
    } else if ($panelDialog) {
      $panelDialog.focus();
    }
  }

  function closePanel(sectionEl, options) {
    const $panel = getPanel(sectionEl);
    const state = getFilterState(sectionEl);
    const focusTarget = state && state.lastFocusedElement;
    const resolvedOptions = options || {};

    if (!$panel || !state) return;

    $panel.classList.remove(PANEL_OPEN_CLASS);

    if (!document.querySelector('.' + PANEL_OPEN_CLASS)) {
      document.body.style.overflow = '';
    }

    if (
      !resolvedOptions.skipFocus &&
      focusTarget &&
      typeof focusTarget.focus === 'function' &&
      document.contains(focusTarget)
    ) {
      focusTarget.focus();
    }

    state.lastFocusedElement = null;
  }

  function trapPanelFocus(sectionEl, event) {
    if (event.key !== 'Tab') return;

    const focusableElements = getPanelFocusableElements(sectionEl);
    const $panelDialog = getPanelDialog(sectionEl);

    if (!focusableElements.length) {
      event.preventDefault();
      if ($panelDialog) $panelDialog.focus();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function restorePanelFocusTarget(sectionEl) {
    const state = getFilterState(sectionEl);
    if (!state) return;

    state.lastFocusedElement = sectionEl.querySelector('[data-refine-toggle]');
  }

  function setCollectionLoading(sectionEl, isLoading) {
    if (!sectionEl) return;

    if (isLoading) {
      sectionEl.setAttribute('aria-busy', 'true');
    } else {
      sectionEl.removeAttribute('aria-busy');
    }
  }

  function abortLoadMoreRequest(sectionEl) {
    const state = getFilterState(sectionEl);
    if (!state || !state.loadMoreAbortController) return;

    if (typeof state.loadMoreAbortController.abort === 'function') {
      state.loadMoreAbortController.abort();
    }

    state.loadMoreAbortController = null;
  }

  function abortRestoreRequest(sectionEl) {
    const state = getFilterState(sectionEl);
    if (!state || !state.restoreAbortController) return;

    if (typeof state.restoreAbortController.abort === 'function') {
      state.restoreAbortController.abort();
    }

    state.restoreAbortController = null;
  }

  function clearFormState(form) {
    if (!form) return;

    function uncheckFilter(checkbox) {
      checkbox.checked = false;
    }

    function removeHiddenField(hiddenField) {
      hiddenField.remove();
    }

    forEachNode(form.querySelectorAll('input[type="checkbox"]'), uncheckFilter);
    forEachNode(
      form.querySelectorAll('[data-refine-active-hidden-filter]'),
      removeHiddenField,
    );
  }

  function uncheckSiblingCheckboxes(checkboxes, currentCheckbox) {
    function uncheckSibling(checkbox) {
      if (checkbox !== currentCheckbox) {
        checkbox.checked = false;
      }
    }

    forEachNode(checkboxes, uncheckSibling);
  }

  function buildFormUrl(form) {
    const url = getUrlObject(
      form.getAttribute('action') || window.location.href,
    );
    const formData = new FormData(form);
    const params = new URLSearchParams();

    function appendFormValue(value, key) {
      if (value === '' || value == null) return;
      params.append(key, value);
    }

    formData.forEach(appendFormValue);

    params.delete('section_id');
    url.search = params.toString();
    url.hash = '';

    return url;
  }

  function applyPageHtml(doc, sectionEl, grid, button, wrapper, storageKey) {
    const $newGrid = doc.querySelector('[data-collection-grid]');
    const $newButton = doc.querySelector('[data-load-more-btn]');
    const $newSummary = doc.querySelector('.product-grid__btn__hover-text');

    if (!$newGrid) return { hasGrid: false, hasMore: false };

    while ($newGrid.firstElementChild) {
      grid.appendChild($newGrid.firstElementChild);
    }

    const $currentSummary = sectionEl.querySelector(
      '.product-grid__btn__hover-text',
    );
    if ($currentSummary && $newSummary) {
      $currentSummary.innerHTML = $newSummary.innerHTML;
    }

    setStoredCount(storageKey, grid.children.length);

    if ($newButton && $newButton.getAttribute('data-next-url')) {
      button.setAttribute(
        'data-next-url',
        $newButton.getAttribute('data-next-url'),
      );
      return { hasGrid: true, hasMore: true };
    }

    if (wrapper && wrapper.parentNode) {
      wrapper.parentNode.removeChild(wrapper);
    } else if (button.parentNode) {
      button.parentNode.removeChild(button);
    }

    return { hasGrid: true, hasMore: false };
  }

  async function loadNextPage(
    sectionEl,
    grid,
    button,
    wrapper,
    storageKey,
    signal,
  ) {
    const nextUrl = button.getAttribute('data-next-url');
    if (!nextUrl) return { done: true };

    if (typeof window.fetch !== 'function') {
      window.location.href = nextUrl;
      return { done: true };
    }

    const defaultLabel =
      button.getAttribute('data-load-more-label') || button.textContent;
    const loadingLabel =
      button.getAttribute('data-loading-label') || defaultLabel;

    button.textContent = loadingLabel;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    function onNextPageLoaded(doc) {
      const result = applyPageHtml(
        doc,
        sectionEl,
        grid,
        button,
        wrapper,
        storageKey,
      );
      if (!result.hasGrid) {
        window.location.href = nextUrl;
        return { done: true };
      }

      button.textContent = defaultLabel;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      return { done: !result.hasMore };
    }

    function onNextPageError(error) {
      if (error && error.name === 'AbortError') {
        button.textContent = defaultLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        return { done: true };
      }

      if (nextUrl) window.location.href = nextUrl;
      return { done: true };
    }

    try {
      const doc = await fetchPageDoc(nextUrl, signal);
      return onNextPageLoaded(doc);
    } catch (error) {
      return onNextPageError(error);
    }
  }

  function restoreFromStorage(sectionEl, grid, button, wrapper, storageKey) {
    const state = getFilterState(sectionEl);
    if (!state) return;

    const storedCount = getStoredCount(storageKey);
    if (!storedCount) return;
    if (!button || !button.getAttribute('data-next-url')) return;
    if (grid.children.length >= storedCount) return;
    if (typeof window.fetch !== 'function') return;

    const pageSize = grid.children.length;
    if (!pageSize) return;

    const nextUrl = button.getAttribute('data-next-url');
    const origin = window.location.origin;
    let currentPage = 1;

    try {
      const parsedNextUrl = new URL(nextUrl, origin);
      const nextPageNum = parseInt(
        parsedNextUrl.searchParams.get('page') || '2',
        10,
      );
      if (!isNaN(nextPageNum) && nextPageNum > 1) currentPage = nextPageNum - 1;
    } catch (error) {
      return;
    }

    const needed = storedCount - grid.children.length;
    if (needed <= 0) return;

    const pagesNeeded = Math.ceil(needed / pageSize);
    const highestPage = currentPage + pagesNeeded;
    if (highestPage <= currentPage) return;

    let urls = [];

    for (let page = currentPage + 1; page <= highestPage; page += 1) {
      try {
        const pageUrl = new URL(nextUrl, origin);
        pageUrl.searchParams.set('page', String(page));
        urls.push(pageUrl.pathname + pageUrl.search + pageUrl.hash);
      } catch (error) {
        urls = [];
        break;
      }
    }

    if (!urls.length) return;

    const originalDisabled = button.disabled;
    button.disabled = true;

    abortRestoreRequest(sectionEl);
    const restoreAbortController =
      typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
    state.restoreAbortController = restoreAbortController;

    function fetchDocForRestore(url) {
      function onRestoreFetchError(error) {
        if (error && error.name === 'AbortError') {
          return null;
        }

        return null;
      }

      return fetchPageDoc(
        url,
        restoreAbortController ? restoreAbortController.signal : null,
      ).catch(onRestoreFetchError);
    }

    function applyRestoredDocs(docs) {
      if (state.restoreAbortController !== restoreAbortController) return;

      for (let index = 0; index < docs.length; index += 1) {
        const doc = docs[index];
        if (!doc) continue;
        applyPageHtml(doc, sectionEl, grid, button, wrapper, storageKey);
      }
    }

    function restoreButtonState() {
      if (state.restoreAbortController !== restoreAbortController) return;

      state.restoreAbortController = null;
      button.disabled = originalDisabled;
    }

    Promise.all(urls.map(fetchDocForRestore))
      .then(applyRestoredDocs)
      .then(restoreButtonState);
  }

  function initCollectionLoadMore(sectionEl, options) {
    if (!sectionEl) return;

    const resolvedOptions = options || {};
    const grid = sectionEl.querySelector('[data-collection-grid]');
    const button = sectionEl.querySelector('[data-load-more-btn]');
    const wrapper = sectionEl.querySelector('[data-load-more-wrapper]');
    const storageKey = getStorageKey(resolvedOptions.url);
    const shouldRestore = resolvedOptions.restoreFromStorage !== false;
    const storedCount = getStoredCount(storageKey);

    if (!grid) return;

    if (!button) {
      setStoredCount(storageKey, grid.children.length);
      return;
    }

    let isLoading = false;

    if (button._collectionLoadMoreBound) return;
    button._collectionLoadMoreBound = true;

    if (shouldRestore && storedCount) {
      restoreFromStorage(sectionEl, grid, button, wrapper, storageKey);
    } else {
      setStoredCount(storageKey, grid.children.length);
    }

    function onLoadMoreClick() {
      if (isLoading) return;

      const nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) {
        button.disabled = true;
        if (wrapper) {
          wrapper.style.display = 'none';
        } else if (button.parentNode) {
          button.parentNode.removeChild(button);
        }
        return;
      }

      isLoading = true;

      const state = getFilterState(sectionEl);
      abortLoadMoreRequest(sectionEl);
      state.loadMoreAbortController =
        typeof window.AbortController === 'function'
          ? new window.AbortController()
          : null;

      function onLoadMoreCompleted() {
        if (state) {
          state.loadMoreAbortController = null;
        }

        isLoading = false;
      }

      loadNextPage(
        sectionEl,
        grid,
        button,
        wrapper,
        storageKey,
        state && state.loadMoreAbortController
          ? state.loadMoreAbortController.signal
          : null,
      ).then(onLoadMoreCompleted);
    }

    button.addEventListener('click', onLoadMoreClick);
  }

  function renderCollectionSection(sectionEl, targetUrl, options) {
    if (!sectionEl) return Promise.resolve();

    const resolvedOptions = options || {};
    const state = getFilterState(sectionEl);
    const target = getUrlObject(targetUrl);
    const sectionId = getSectionId(sectionEl);
    const $currentWrapper = getDynamicContent(sectionEl);
    const keepDrawerOpen =
      typeof resolvedOptions.preserveDesktopDrawer === 'boolean'
        ? resolvedOptions.preserveDesktopDrawer
        : isDrawerOpen(sectionEl) && !isMobileViewport();

    if (!sectionId || !$currentWrapper) return Promise.resolve();

    target.searchParams.delete('section_id');

    state.requestId += 1;
    const requestId = state.requestId;

    abortRestoreRequest(sectionEl);
    abortLoadMoreRequest(sectionEl);

    if (
      state.abortController &&
      typeof state.abortController.abort === 'function'
    ) {
      state.abortController.abort();
    }

    state.abortController =
      typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;

    setCollectionLoading(sectionEl, true);

    const requestUrl = getUrlObject(target.toString());
    requestUrl.searchParams.set('section_id', sectionId);

    function applyFetchedWrapper($nextWrapper, forceEmptyGrid) {
      const shouldClosePanel =
        resolvedOptions.closePanelOnSuccess || isPanelOpen(sectionEl);

      if (forceEmptyGrid) {
        const $nextGrid = $nextWrapper.querySelector('[data-collection-grid]');
        const $nextLoadMoreWrapper = $nextWrapper.querySelector(
          '[data-load-more-wrapper]',
        );

        if ($nextGrid) {
          while ($nextGrid.firstChild) {
            $nextGrid.removeChild($nextGrid.firstChild);
          }
        }

        if ($nextLoadMoreWrapper) {
          $nextLoadMoreWrapper.remove();
        }
      }

      syncInStockFilterInputs(sectionEl, $nextWrapper, target.toString());

      $currentWrapper.replaceWith($nextWrapper);

      if (shouldClosePanel) {
        restorePanelFocusTarget(sectionEl);
        closePanel(sectionEl);
      }

      if (keepDrawerOpen && !isMobileViewport()) {
        openDrawer(sectionEl, true);
      } else {
        closeDrawer(sectionEl, true);
      }

      state.currentSearch = target.search;

      if (resolvedOptions.updateHistory !== false) {
        window.history.pushState(
          { searchParams: target.search.slice(1) },
          '',
          toRelativeUrl(target.toString()),
        );
      }

      initCollectionLoadMore(sectionEl, {
        restoreFromStorage: false,
        url: target.toString(),
      });
    }

    function getFetchedWrapper(doc) {
      const $nextSection = doc.querySelector(
        '[data-collection-section][data-section-id="' + sectionId + '"]',
      );

      return $nextSection
        ? $nextSection.querySelector('[data-collection-dynamic-content]')
        : null;
    }

    function onSectionFetched(doc) {
      if (requestId !== state.requestId) return;

      const $nextWrapper = getFetchedWrapper(doc);

      if (!$nextWrapper) {
        return fetchPageDoc(
          target.toString(),
          state.abortController ? state.abortController.signal : null,
        ).then(function onFallbackPageFetched(fallbackDoc) {
          if (requestId !== state.requestId) return;

          const $fallbackWrapper = getFetchedWrapper(fallbackDoc);
          if (!$fallbackWrapper) {
            window.location.assign(toRelativeUrl(target.toString()));
            return;
          }

          applyFetchedWrapper($fallbackWrapper, false);
        });
      }

      applyFetchedWrapper($nextWrapper, false);
    }

    function onSectionFetchFailed(error) {
      if (error && error.name === 'AbortError') return;
      if (requestId !== state.requestId) return;

      return fetchPageDoc(
        target.toString(),
        state.abortController ? state.abortController.signal : null,
      )
        .then(function onFallbackPageFetched(fallbackDoc) {
          if (requestId !== state.requestId) return;

          const $fallbackWrapper = getFetchedWrapper(fallbackDoc);
          if (!$fallbackWrapper) {
            window.location.assign(toRelativeUrl(target.toString()));
            return;
          }

          applyFetchedWrapper($fallbackWrapper, false);
        })
        .catch(function onFallbackPageFailed() {
          if (requestId !== state.requestId) return;
          window.location.assign(toRelativeUrl(target.toString()));
        });
    }

    function onSectionFetchSettled() {
      if (requestId !== state.requestId) return;
      state.abortController = null;
      setCollectionLoading(sectionEl, false);
    }

    return fetchPageDoc(
      requestUrl.toString(),
      state.abortController ? state.abortController.signal : null,
    )
      .then(onSectionFetched)
      .catch(onSectionFetchFailed)
      .then(onSectionFetchSettled)
      .catch(onSectionFetchSettled);
  }

  function bindCollectionFilters(sectionEl) {
    if (!sectionEl || sectionEl._collectionFiltersBound) return;

    sectionEl._collectionFiltersBound = true;
    getFilterState(sectionEl).currentSearch = window.location.search;

    function onSectionClick(event) {
      const panelOption = event.target.closest(
        '.product-grid__filters__panel__accordion__option',
      );
      if (panelOption && sectionEl.contains(panelOption)) {
        event.stopPropagation();
      }

      const refineToggle = event.target.closest('[data-refine-toggle]');
      if (refineToggle && sectionEl.contains(refineToggle)) {
        event.preventDefault();
        if (isMobileViewport()) {
          if (isPanelOpen(sectionEl)) {
            closePanel(sectionEl);
          } else {
            openPanel(sectionEl);
          }
        } else {
          toggleDrawer(sectionEl);
        }
        return;
      }

      const refineClose = event.target.closest('[data-refine-close]');
      if (refineClose && sectionEl.contains(refineClose)) {
        event.preventDefault();
        closeDrawer(sectionEl);
        return;
      }

      const panelClose = event.target.closest('[data-refine-panel-close]');
      if (panelClose && sectionEl.contains(panelClose)) {
        event.preventDefault();
        closePanel(sectionEl);
        return;
      }

      const refineClear = event.target.closest('[data-refine-clear]');
      if (refineClear && sectionEl.contains(refineClear)) {
        event.preventDefault();
        const desktopForm = getDesktopForm(sectionEl);
        if (!desktopForm) return;
        clearFormState(desktopForm);
        renderCollectionSection(sectionEl, buildFormUrl(desktopForm), {
          preserveDesktopDrawer: true,
        });
        return;
      }

      const sortRemove = event.target.closest('[data-sort-remove]');
      if (sortRemove && sectionEl.contains(sortRemove)) {
        event.preventDefault();
        const sortForm = getDesktopForm(sectionEl);
        if (!sortForm) return;

        function uncheckSortCheckbox(checkbox) {
          checkbox.checked = false;
        }

        forEachNode(
          sortForm.querySelectorAll('[data-sort-checkbox]'),
          uncheckSortCheckbox,
        );

        renderCollectionSection(sectionEl, buildFormUrl(sortForm), {
          preserveDesktopDrawer: true,
        });
        return;
      }

      const panelClear = event.target.closest('[data-refine-panel-clear]');
      if (panelClear && sectionEl.contains(panelClear)) {
        event.preventDefault();
        const mobileForm = getMobileForm(sectionEl);
        if (!mobileForm) return;
        clearFormState(mobileForm);
        renderCollectionSection(sectionEl, buildFormUrl(mobileForm), {
          closePanelOnSuccess: true,
          preserveDesktopDrawer: false,
        });
        return;
      }

      const appliedChip = event.target.closest(
        '.product-grid__filters__applied[href]',
      );
      if (appliedChip && sectionEl.contains(appliedChip)) {
        event.preventDefault();
        renderCollectionSection(sectionEl, appliedChip.href, {
          preserveDesktopDrawer: isDrawerOpen(sectionEl) && !isMobileViewport(),
          closePanelOnSuccess: isPanelOpen(sectionEl),
        });
        return;
      }

      const panel = getPanel(sectionEl);
      if (panel && event.target === panel) {
        closePanel(sectionEl);
      }
    }

    function onSectionChange(event) {
      const desktopForm = getDesktopForm(sectionEl);
      if (desktopForm && desktopForm.contains(event.target)) {
        if (
          event.target.matches('[data-sort-checkbox]') &&
          event.target.checked
        ) {
          uncheckSiblingCheckboxes(
            desktopForm.querySelectorAll('[data-sort-checkbox]'),
            event.target,
          );
        }

        renderCollectionSection(sectionEl, buildFormUrl(desktopForm), {
          preserveDesktopDrawer: true,
        });
        return;
      }

      const mobileForm = getMobileForm(sectionEl);
      if (!mobileForm || !mobileForm.contains(event.target)) return;

      if (
        event.target.matches(
          '.product-grid__filters__panel__accordion__input',
        ) &&
        event.target.checked
      ) {
        uncheckSiblingCheckboxes(
          mobileForm.querySelectorAll(
            '.product-grid__filters__panel__accordion__input',
          ),
          event.target,
        );
        return;
      }

      if (
        event.target.matches('[data-panel-sort-checkbox]') &&
        event.target.checked
      ) {
        uncheckSiblingCheckboxes(
          mobileForm.querySelectorAll('[data-panel-sort-checkbox]'),
          event.target,
        );
      }
    }

    function onSectionSubmit(event) {
      const desktopForm = getDesktopForm(sectionEl);
      const mobileForm = getMobileForm(sectionEl);

      if (event.target === desktopForm) {
        event.preventDefault();
        renderCollectionSection(sectionEl, buildFormUrl(event.target), {
          preserveDesktopDrawer: true,
        });
        return;
      }

      if (event.target === mobileForm) {
        event.preventDefault();
        renderCollectionSection(sectionEl, buildFormUrl(event.target), {
          closePanelOnSuccess: true,
          preserveDesktopDrawer: false,
        });
      }
    }

    function onDocumentClick(event) {
      if (!document.documentElement.contains(sectionEl)) return;
      if (!isDrawerOpen(sectionEl)) return;
      if (event.target.closest('.product-grid__filters')) return;
      closeDrawer(sectionEl);
    }

    function onDocumentKeyDown(event) {
      if (!document.documentElement.contains(sectionEl)) return;
      if (!isPanelOpen(sectionEl)) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel(sectionEl);
        return;
      }

      trapPanelFocus(sectionEl, event);
    }

    sectionEl.addEventListener('click', onSectionClick);
    sectionEl.addEventListener('change', onSectionChange);
    sectionEl.addEventListener('submit', onSectionSubmit);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeyDown);

    function teardownCollectionFilters() {
      sectionEl.removeEventListener('click', onSectionClick);
      sectionEl.removeEventListener('change', onSectionChange);
      sectionEl.removeEventListener('submit', onSectionSubmit);
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onDocumentKeyDown);
      clearDrawerTimer(sectionEl);

      if (isPanelOpen(sectionEl)) {
        closePanel(sectionEl, { skipFocus: true });
      }

      sectionEl._collectionFiltersBound = false;
      sectionEl._collectionFiltersTeardown = null;
    }

    sectionEl._collectionFiltersTeardown = teardownCollectionFilters;
  }

  function unbindCollectionFilters(sectionEl) {
    if (!sectionEl) return;

    if (typeof sectionEl._collectionFiltersTeardown === 'function') {
      sectionEl._collectionFiltersTeardown();
      return;
    }
  }

  function initCollectionSection(sectionEl, options) {
    if (!sectionEl) return;

    syncInStockFilterInputs(
      sectionEl,
      getDynamicContent(sectionEl),
      window.location.href,
    );
    bindCollectionFilters(sectionEl);
    initCollectionLoadMore(sectionEl, options);
  }

  function initAllCollectionSections() {
    try {
      const sections = document.querySelectorAll('[data-collection-section]');
      if (!sections || !sections.length) return;

      function initializeSection(sectionEl) {
        initCollectionSection(sectionEl);
      }

      forEachNode(sections, initializeSection);
    } catch (error) {}
  }

  function syncSectionsToLocation() {
    const sections = document.querySelectorAll('[data-collection-section]');

    function syncSection(sectionEl) {
      const state = getFilterState(sectionEl);
      if (!state || state.currentSearch === window.location.search) return;

      renderCollectionSection(sectionEl, window.location.href, {
        updateHistory: false,
        preserveDesktopDrawer: false,
        closePanelOnSuccess: isPanelOpen(sectionEl),
      });
    }

    forEachNode(sections, syncSection);
  }

  function getCollectionSectionFromEvent(event) {
    const target = event.target;

    if (
      target &&
      target.matches &&
      target.matches('[data-collection-section]')
    ) {
      return target;
    }

    if (target && target.querySelector) {
      const nestedSection = target.querySelector('[data-collection-section]');
      if (nestedSection) return nestedSection;
    }

    if (event.detail && event.detail.sectionId) {
      return document.querySelector(
        '[data-section-id="' + event.detail.sectionId + '"]',
      );
    }

    return null;
  }

  function onShopifySectionLoad(event) {
    try {
      const target = getCollectionSectionFromEvent(event);

      if (
        !target ||
        !target.matches ||
        !target.matches('[data-collection-section]')
      ) {
        return;
      }

      initCollectionSection(target);
    } catch (error) {}
  }

  function onShopifySectionUnload(event) {
    try {
      const target = getCollectionSectionFromEvent(event);
      unbindCollectionFilters(target);
    } catch (error) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionSections);
  } else {
    initAllCollectionSections();
  }

  window.addEventListener('popstate', syncSectionsToLocation);
  document.addEventListener('shopify:section:load', onShopifySectionLoad);
  document.addEventListener('shopify:section:unload', onShopifySectionUnload);
})();
